import { Component, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogDto } from '@coin/importer/dto/util';
import { LogsService } from '../../services/logs/logs.service';
import { ToastService } from '../../services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UpperCasePipe, DatePipe } from '@angular/common';
import { FileNamePipe } from '../../pipes/file-name/file-name.pipe';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { TurbineComponent } from '@coin/importer/core/feature';

@Component({
  selector: 'importer-skip-previous-imports-popup',
  templateUrl: './skip-previous-imports-popup.component.html',
  styleUrls: ['./skip-previous-imports-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TurbineComponent, V2ButtonComponent, UpperCasePipe, DatePipe, FileNamePipe]
})
export class SkipPreviousImportsPopupComponent {
  matDialogRef = inject<MatDialogRef<SkipPreviousImportsPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private readonly logService = inject(LogsService);
  private readonly toast = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  loadingPopupData: boolean;
  showConfirmation: boolean;
  currentLog: LogDto;
  logsAheadInQueue: LogDto[] = [];

  constructor() {
    this.showConfirmation = false;
    this.currentLog = this.data.element;
    if (this.currentLog) {
      if (this.currentLog.fileType?.threshold) {
        this.toast.warn(
          'Uploads of this file type are handled by an automatic decision process. Manual interference is not possible.'
        );
        this.close();
      }

      this.loadingPopupData = true;
      this.logService
        .getPreviousQueuedLogs(this.currentLog.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
          logs => {
            this.logsAheadInQueue = logs;
          },
          null,
          () => {
            this.loadingPopupData = false;
          }
        );
    } else {
      this.toast.error('could not find any data');
      this.close();
    }
  }

  close(reload = false) {
    this.loadingPopupData = false;
    this.matDialogRef.close(reload);
  }

  submit() {
    this.loadingPopupData = true;
    if (this.currentLog) {
      this.logService
        .rejectPreviousQueuedLogs(this.currentLog.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
          response => {
            if (response.length) {
              this.toast.success(
                `${response.length} previous queued imports have been rejected - STAGING of current job has started.`
              );
              this.close(true);
            } else {
              this.toast.warn('no Jobs have been updated');
              this.close();
            }
          },
          response => {
            this.toast.error(response.error?.message || 'unknown Error');
            this.close();
          }
        );
    }
  }
}
